import React from 'react'
import { utils } from 'alelo-logic'

import { Container, Currency, Info, ValueLabel, InvoiceValue, Details } from './styles'

const { currencyParser } = utils

const DashboardInvoiceCard = ({ currentAccountPlan }) => {
  return (
    currentAccountPlan && (
      <Container>
        <Info>
          <InvoiceValue>
            <ValueLabel>Fatura Atual</ValueLabel>
            <Currency>
              <span>R$</span>
              {currencyParser(currentAccountPlan.ammount)}
            </Currency>
          </InvoiceValue>
          <InvoiceValue>
            <ValueLabel>Limite Disponível</ValueLabel>
            <Currency lightBlue>
              <span>R$</span>
              {currencyParser(currentAccountPlan.availableAmount)}
            </Currency>
          </InvoiceValue>
        </Info>
        <Details>
          <p>
            Fechamento da fatura em{' '}
            <span>
              {currentAccountPlan.posData && utils.ISODateFormat(currentAccountPlan.posData.cutDay)}
            </span>
          </p>
          <p>
            Vencimento em{' '}
            <span>
              {currentAccountPlan.posData && utils.ISODateFormat(currentAccountPlan.posData.payDay)}
            </span>
          </p>
        </Details>
      </Container>
    )
  )
}

export default DashboardInvoiceCard



// WEBPACK FOOTER //
// ./src/app/elements/DashboardInvoiceCard/index.js